import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faMapMarkerAlt, faClock, faUser, faPen, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import SocialIcons from '../components/SocialIcons';

const Contact: React.FC = () => {
  // Form state and feedback
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');

  // Simple validation
  const validate = () => {
    const newErrors: { [key: string]: string } = {};
    if (!formData.name.trim()) newErrors.name = 'Le nom est requis';
    if (!formData.email.trim()) newErrors.email = 'L\'email est requis';
    else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(formData.email)) newErrors.email = 'Email invalide';
    if (!formData.subject.trim()) newErrors.subject = 'Le sujet est requis';
    if (!formData.message.trim()) newErrors.message = 'Le message est requis';
    return newErrors;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setSuccess('');
      return;
    }
    setLoading(true);
    setSuccess('');
    // Simulate async send
    setTimeout(() => {
      setLoading(false);
      setSuccess('Votre message a été envoyé avec succès!');
      setFormData({ name: '', email: '', subject: '', message: '' });
    }, 1500);
  };

  // vCard download
  const handleVCardDownload = () => {
    const vCard = `BEGIN:VCARD\nVERSION:3.0\nFN:Dr. Banelhaq Ayoub\nORG:Cabinet Dentaire\nTEL;TYPE=WORK,VOICE:+212684707407\nEMAIL:contact@dentiste-tanger.com\nADR;TYPE=WORK:;;123 Avenue Mohammed V;Tanger;;Maroc\nEND:VCARD`;
    const blob = new Blob([vCard], { type: 'text/vcard' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'dentiste-tanger.vcf';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="relative" style={{ paddingTop: 'calc(5rem + var(--announcement-offset, 0px))' }}>
      {/* Social Icons floating */}
      <SocialIcons />
      {/* Hero Section */}
      <div className="bg-accent text-white py-20 relative overflow-hidden animate-fade-in-up">
        <div className="absolute inset-0 bg-gradient-to-b from-accent to-black opacity-80"></div>
        <div className="relative z-10 section-container text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Contactez-nous</h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Notre équipe est à votre disposition pour répondre à toutes vos questions et vous accompagner dans vos soins dentaires.
          </p>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="section-container contact-section-container py-16">
        

        {/* Contact Information and Map */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Details */}
          <div className="space-y-8">
            <div className="bg-white rounded-xl shadow-card p-8">
              <h2 className="text-2xl font-bold text-accent mb-6 text-center">Contactez-nous</h2>
              <div className="space-y-6 text-center">
                <div className="flex flex-col items-center">
                  <div className="h-12 w-12 bg-primary rounded-full flex items-center justify-center mb-2">
                    <FontAwesomeIcon icon={faPhone} className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900">Téléphone</h3>
                  <a href="tel:+212684707407" className="text-gray-600 hover:text-primary transition-colors">
                    +212 684-707407
                  </a>
                  <a href="tel:+212539434067" className="text-gray-600 hover:text-primary transition-colors">
                  +212 539-434067
                  </a>
                </div>
                <div className="flex flex-col items-center">
                  <div className="h-12 w-12 bg-primary rounded-full flex items-center justify-center mb-2">
                    <FontAwesomeIcon icon={faEnvelope} className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900">Email</h3>
                  <a href="mailto:contact@dentiste-tanger.com" className="text-gray-600 hover:text-primary transition-colors">
                  dental.banelhaq@gmail.com 
                  </a>
                </div>
                <div className="flex flex-col items-center">
                  <div className="h-12 w-12 bg-primary rounded-full flex items-center justify-center mb-2">
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900">Adresse</h3>
                  <p className="text-gray-600">
N 86 Lotissement Karima 3, 2ème étage <br></br> Av Royaume d'arabie saoudite<br></br> En face hotel Ahlan <br></br>Tanger
                  </p>
                </div>
                <div className="flex flex-col items-center">
                  <div className="h-12 w-12 bg-primary rounded-full flex items-center justify-center mb-2">
                    <FontAwesomeIcon icon={faClock} className="h-6 w-6 text-white" />
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900">Horaires d'ouverture</h3>
                  <p className="text-gray-600">
                    Lundi - Vendredi: 9h00 - 19h00<br />
                    Samedi: 9h00 - 13h00<br />
                    Dimanche: Fermé
                  </p>
                </div>
              </div>
            </div>

            {/* WhatsApp CTA */}
            <div className="bg-green-600 text-white rounded-xl shadow-card p-8">
              <h3 className="text-xl font-bold mb-4">Besoin d'une réponse rapide?</h3>
              <p className="mb-6">Contactez-nous directement sur WhatsApp pour une réponse immédiate.</p>
              <a 
                href="https://wa.me/212684707407" 
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white text-green-600 hover:bg-gray-100 font-medium px-6 py-3 rounded-md transition-colors inline-flex items-center"
              >
                <svg className="w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                Contacter via WhatsApp
              </a>
            </div>
          </div>

          {/* Map */}
          <div>
            <div className="bg-white rounded-xl shadow-card overflow-hidden h-full">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3367.964964432501!2d-5.84238!3d35.7472789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd0b872651725e0b%3A0xaee4928dbd319fcd!2sCabinet%20dentaire%20Dr.%20Banelhaq%20Ayoub!5e0!3m2!1sfr!2sma!4v1717171717171!5m2!1sfr!2sma"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Localisation du cabinet dentaire"
                className="min-h-[400px]"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 